module.exports = __webpack_public_path__ + "img/briefing.12470779.png";